<template>
    <m-pane
        ref="tablePage"
        class="warning-detail"
        :config="config"
        :totalData="totalData"
        :pageTotal="pageTotal"
        :searchTotalTitle="config.searchTotalTitle"
        :loading="loading"
        :pickerConfig="config.pickerConfig"
        searchId="performance-inTransitWarningQuery"
        pageID="performance-inTransitWarning"
        moduleCode="lsp-warning-handle-detail"
        :currentPage="query.pageNo"
        @search-list-change="searchListChange"
        @row-db-click="viewDetail"
        @viewDetail-btn="viewDetail"
        @searchChange="searchChange"
        @selectChange="selectChange"
        @pageChange="pageChange"
        @sizeChange="sizeChange"
    >
        <template v-slot:customTableCell="{row, col}">
            <div class="table-list-encrypted-panel">
                <span :style="cellStyle(row, col)">{{ row[col.prop] }}</span>
            </div>
        </template>
        <div slot="table-module-btn">
            <reportExport
                #default="{ submit }"
                reportCode="OTP_IN_TRANSIT_WARNING_EXPORT"
            >
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <span v-has="'/performance/collusion-warning/export'" class="mgl-10">
                        <el-button
                            icon="icon-daochu"
                            size="mini"
                            :disabled="!pageTotal"
                            @click="exportFile(submit)"
                        ></el-button>
                    </span>
                </el-tooltip>
            </reportExport>
            <reportExport
                #default="{ submit }"
                reportCode="OTP_COLLUSION_WARN_EXPORT_DETAIL"
            >
                <el-tooltip effect="dark" content="导出预警明细" placement="bottom">
                    <span v-has="'/performance/collusion-warning/exportDetail'" class="mgl-10">
                        <el-button
                            icon="icon-daochu"
                            size="mini"
                            :disabled="!pageTotal"
                            @click="exportDetailFile(submit)"
                        ></el-button>
                    </span>
                </el-tooltip>
            </reportExport>
        </div>
    </m-pane>
</template>
<script>
import bigDataLog from '@/utils/bigDataLog';
import { queryMonitorByPage, queryMonitorCount } from '@/modules/transport/otp/api/collusionWarning';
import reportExport from '@/components/lots/reportExportPlugin';
import mPane from '@/components/otpPanel';
import { formatSearchData, validateSearchData, formatTotalDataList } from './util.js';
import config from './config.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { mapState } from 'vuex';

export default {
    name: 'CollusionWarningDetail',
    components: {
        mPane,
        reportExport
    },
    data () {
        return {
            config,
            pageTotal: 0,
            loading: false,
            isFirstSearch: true, // 是否第一次查询
            totalData: [],
            selected: [],
            query: { pageNo: 1, pageSize: 20 },
            dictData: {}, // 数据字典集合
            rowData: {}
        };
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant,
            user: state => state.user,
            supplier: state => state.supplier,
        })
    },
    mounted () {
        this.getDicData();
        this.$nextTick(() => {
            // this.initUser();
        });
    },
    methods: {
        /**
         * @description 获取数据字典
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典集合
         * 预警等级: BUNCH_GOODS_EARLY_WARNING_GRADE
         */
        async getDicData() {
            const dict = await dictWithUrl([
                'BUNCH_GOODS_EARLY_WARNING_GRADE', // 预警等级
                'SYS_SUPPLIER_INDUSTRY' // 行业
            ].join(','));
            this.dictData = dict.data;
        },
        cellStyle(row, col) {
            if (col.prop === 'earlyWarningGradeName' && +row.earlyWarningGrade === 2) {
                return 'color: red; font-weight: bold';
            }
        },
        initUser () {
            const searchItem = this.config.searchList.searchTxt.find(item => item.value === 'dispatchCreateUserName');
            if (searchItem) {
                this.$set(searchItem, 'data', this.user.userName);
                this.$refs.tablePage.$refs.searchList.dataInit();
            }
        },
        viewDetail (row) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-detailTab-viewBtn');
            this.$router.push({
                path: '/otp/distribute/collusion-warning-detail',
                query: {
                    dispatchNo: row.dispatchNo
                }
            });
        },
        getList () {
            queryMonitorByPage(this.query)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData);
                    }
                })
                .catch(() => { })
                .finally(() => { this.loading = false; });
        },
        getListPageCount () {
            queryMonitorCount(this.query.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        // 修改分公司，清空服务平台查询条件
        searchListChange (config, data) {
            if (config.value === 'companyName') {
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.siteName = null;
                    this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.siteCode = null;
                });
            }
        },
        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCode: this.supplier.supplierCode, // 供应商端需要加上供应商编码入参
                }
            };
            return _searchData;
        },
        // 查询
        searchChange (data) {
            const searchData = formatSearchData(data);
            const isQueryOk = validateSearchData(searchData);
            if (!isQueryOk) return;
            this.loading = true;
            this.query = this.getSearchData(searchData);
            this.isFirstSearch = false;
            this.getList();
            this.getListPageCount();
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-detailTab-search');
        },
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            const exportParams = {
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                tenantCode: this.currentTenant.tenantCode,
                ...this.query.param
            };
            if (exportParams.monitorStatus === '3') {
                exportParams.monitorStatus = '';
            }
            submit(exportParams);
            this.isFirstSearch = false;
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-detailTab-export');
        },
        exportDetailFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            const exportParams = {
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                tenantCode: this.currentTenant.tenantCode,
                ...this.query.param
            };
            if (exportParams.monitorStatus === '3') {
                exportParams.monitorStatus = '';
            }
            submit(exportParams);
            this.isFirstSearch = false;
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-detailTab-exportDetail');
        },
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
<style lang="less" scoped>
.warning-detail {
    ::v-deep .otp-table {
       .el-table {
            min-height: calc(~'100vh - 186px') !important;
            max-height: calc(~'100vh - 186px') !important;
        }
    }
}
</style>
